import { Component, OnInit } from '@angular/core';
// import { AngularFireAuth } from '@angular/fire/auth';
import { Router } from '@angular/router';
import { NotificationComponent } from '../../shared/components/notification/notification.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { UserDataService } from 'src/app/shared/services/user-data.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  loginPage = '../../../assets/images/healthy-food-medical-equipment.jpg';
  camLogo = '../../../assets/images/crunch&cheer.jpeg';
  sadIcon = '../../../assets/images/sad.png';
  emailId: any;
  password: any;
  hide = true;
  isLoggedIn = false;
  constructor(
    public afAuth: AngularFireAuth,
    private snackbar: MatSnackBar,
    private route: Router,
    private userDataService: UserDataService
  ) {}

  ngOnInit(): void {
    setInterval(() => {
      this.hide = true;
    }, 3000);
  }

  login() {
    this.afAuth
      .signInWithEmailAndPassword(this.emailId, this.password)
      .then((data: any) => {
        // if (data.user?.emailVerified === false) {
        //   this.isLoggedIn = true;
        //   this.sendEmailConfirmation();
        // } else {
        this.isLoggedIn = false;
        this.userDataService.setUserUID(data.user?.uid);
        this.route.navigate(['./layout']);
        sessionStorage.setItem('userUID', data.user?.uid!);
        this.snackbar.openFromComponent(NotificationComponent, {
          data: {
            customMsg: 'Welcome, you are successfully logged In.',
            type: 'success',
          },
        });
        // }
      })
      .catch((error) => {
        this.snackbar.openFromComponent(NotificationComponent, {
          data: {
            customMsg: error.message,
            type: 'error',
          },
        });
      });
  }

  sendEmailConfirmation() {
    this.afAuth.currentUser
      .then((user) => user?.sendEmailVerification())
      .then((data) => {
        console.log(data);
      });
  }
}
